(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('SuggestionDialogController', SuggestionDialogController);

    SuggestionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Suggestion'];

    function SuggestionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Suggestion) {
        var vm = this;

        vm.suggestion = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.suggestion.id !== null) {
                Suggestion.update(vm.suggestion, onSaveSuccess, onSaveError);
            } else {
                Suggestion.save(vm.suggestion, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('womenCellApp:suggestionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.suggestionDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
